"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var filepond_plugin_file_validate_type_1 = __importDefault(require("filepond-plugin-file-validate-type"));
var filepond_plugin_file_validate_size_1 = __importDefault(require("filepond-plugin-file-validate-size"));
var react_filepond_1 = require("react-filepond");
var type_guards_1 = require("../../type-guards");
(0, react_filepond_1.registerPlugin)(filepond_plugin_file_validate_type_1.default, filepond_plugin_file_validate_size_1.default);
function MessageInputArea(_a) {
    var _b;
    var addMessage = _a.addMessage, openChat = _a.openChat, latestRequest = _a.latestRequest;
    var MAX_TOTAL_FILE_SIZE = "25MB"; // if you want to increase, update in php.ini + nginx.config too
    var MAX_FILES = 20; // if you want to increase, update in php.ini
    var initMessage = {
        id: "temp-".concat(new Date().getTime()),
        chat_id: openChat.id,
        sender_type: openChat.user_role,
        landlordId: openChat.landlord_id,
        message: null,
        read: null,
        files: [],
        created: new Date().toISOString(),
        request_id: null,
        type: "PLAIN",
    };
    var textareaRef = (0, react_1.useRef)(null);
    var dropdownRef = (0, react_1.useRef)(null);
    var _c = (0, react_1.useState)(false), showUpload = _c[0], setShowUpload = _c[1];
    var _d = (0, react_1.useState)(initMessage), message = _d[0], setMessage = _d[1];
    var senderBlocked = openChat.user_role === "LANDLORD"
        ? openChat.tenant_blocked
        : openChat.landlord_blocked;
    (0, react_1.useEffect)(function () {
        adjustTextareaHeight();
    }, [message.message]);
    var handleFormSubmit = function (e) {
        e.preventDefault();
        // only send message if it's not empty
        if ((message.message === null || message.message.trim() === "") &&
            message.files.length === 0) {
            return;
        }
        setMessage(initMessage);
        addMessage(openChat, message);
        setShowUpload(false);
    };
    var handleClickPaymentMethod = function (paymentMethod) {
        var _a;
        var paymentMethodMessage = "Bezahlung m\u00F6glich per ".concat(paymentMethod.type, ":\nIBAN: ").concat(paymentMethod.identifier, "\nBIC: ").concat(paymentMethod.details, "\nKontoinhaber: ").concat(paymentMethod.holder);
        (_a = dropdownRef.current) === null || _a === void 0 ? void 0 : _a.classList.remove("open"); // close the dropdown
        setMessage(function (prev) {
            if (message.message === null) {
                return __assign(__assign({}, prev), { message: paymentMethodMessage });
            }
            else {
                return __assign(__assign({}, prev), { message: prev.message + "\n" + paymentMethodMessage });
            }
        });
    };
    var adjustTextareaHeight = function () {
        if (textareaRef.current) {
            textareaRef.current.style.height = "auto";
            textareaRef.current.style.height = "".concat(textareaRef.current.scrollHeight, "px");
        }
    };
    var removeDatabaseFiles = function (files) {
        return files.filter(function (file) {
            return (0, type_guards_1.isDatabaseFile)(file) ? false : true;
        });
    };
    var handleClickFileUploadIcon = function () {
        var _a;
        message.files.length === 0 && setShowUpload(!showUpload);
        (_a = dropdownRef.current) === null || _a === void 0 ? void 0 : _a.classList.remove("open");
    };
    var handleClickPaymentMethodIcon = function (e) {
        if (showUpload) {
            e.stopPropagation();
            e.preventDefault();
        }
    };
    if (senderBlocked) {
        return (react_1.default.createElement("div", { id: "chat-window-input-group", className: "sender-blocked text py-2 px-5 d-flex align-items-center" }, window.Translator.trans("chat.message_blocker", {}, "js")));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("form", { id: "chat-window-input-group", className: "py-1 px-3 d-flex flex-column", onSubmit: function (e) { return handleFormSubmit(e); } },
            showUpload && (react_1.default.createElement(react_filepond_1.FilePond, { files: removeDatabaseFiles(message.files), onupdatefiles: function (filePondFiles) {
                    return setMessage(function (prev) {
                        return __assign(__assign({}, prev), { files: filePondFiles.map(function (file) { return file.file; }) });
                    });
                }, maxTotalFileSize: MAX_TOTAL_FILE_SIZE, maxFiles: MAX_FILES, acceptedFileTypes: [
                    "application/msword",
                    "application/vnd.ms-excel",
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    "application/pdf",
                    "image/heic",
                    "image/jpeg",
                    "image/jpg",
                    "image/png",
                    "text/csv",
                ], allowMultiple: true, name: "files" /* sets the file input name, it's filepond by default */, labelIdle: window.Translator.trans("fileupload.labelIdleFiles.part1", {}, "js") +
                    ' <span class="filepond--label-action">' +
                    window.Translator.trans("fileupload.labelIdleFiles.part2", {}, "js") +
                    "</span>" +
                    "<div class='text small d-flex gap-1 justify-content-center'><span>" +
                    window.Translator.trans("fileupload.labelIdleFiles.part3", {
                        formats: ".jpg, .jpeg, .png, .pdf, .doc, .docx, .xlsx, .csv",
                    }, "js") +
                    "</span><span>" +
                    window.Translator.trans("fileupload.labelIdleFiles.part4", { size: MAX_TOTAL_FILE_SIZE }, "js") +
                    "</span></div>", instantUpload: false, allowProcess: false })),
            react_1.default.createElement("div", { className: "relative d-flex align-items-center" },
                react_1.default.createElement("div", { className: "dropdown flex-shrink-0" },
                    react_1.default.createElement("button", { ref: dropdownRef, type: "button", id: "chat-payment-method-dropdown", "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false", className: "dropdown-toggle", onClick: function (e) { return handleClickPaymentMethodIcon(e); } },
                        react_1.default.createElement("svg", { className: "icon gray mb-0", width: "25", height: "25" },
                            react_1.default.createElement("use", { href: "#fa-euro-sign" }))),
                    react_1.default.createElement("div", { className: "dropdown-menu payment-method absolute left", "aria-labelledby": "chat-payment-method-dropdown" }, openChat.rental.payment_methods.length > 0 ? (react_1.default.createElement("ul", { className: "tl" }, openChat.rental.payment_methods.map(function (paymentMethod) {
                        if (paymentMethod.type !== "CASH")
                            return (react_1.default.createElement("li", { className: "pt-1 d-flex", key: paymentMethod.id },
                                react_1.default.createElement("button", { type: "button", className: "flex-grow-1 p-0 btn btn--sm black", onClick: function () {
                                        return handleClickPaymentMethod(paymentMethod);
                                    } },
                                    react_1.default.createElement("div", { className: "checkbox-panel rounded border p-2 d-flex justify-content-start gap-1" },
                                        react_1.default.createElement("svg", { className: "icon my-n2 flex-shrink-0", width: "45", height: "45" },
                                            react_1.default.createElement("use", { href: "#".concat(paymentMethod.type === "BANK"
                                                    ? "bank"
                                                    : "paypal") })),
                                        react_1.default.createElement("p", { className: "tl p-0" },
                                            react_1.default.createElement("span", { className: "strong" }, paymentMethod.holder),
                                            react_1.default.createElement("br", null),
                                            paymentMethod.identifier,
                                            react_1.default.createElement("br", null),
                                            paymentMethod.type === "PAYPAL"
                                                ? paymentMethod.details === "BUSINESS"
                                                    ? window.Translator.trans("payment_methods.paypal.details.business", {}, "js")
                                                    : window.Translator.trans("payment_methods.paypal.details.personal", {}, "js")
                                                : paymentMethod.details)))));
                    }))) : (react_1.default.createElement("a", { className: "smaller underline black pt-2", href: window.Routing.generate("rental_contact", {
                            rentalId: openChat.rental.id,
                            _locale: lang,
                        }), target: "_blank" },
                        window.Translator.trans("chat.add_payment_methods", {}, "js"),
                        react_1.default.createElement("svg", { className: "icon edit ", width: "15", height: "15" },
                            react_1.default.createElement("use", { href: "#edit" })))))),
                react_1.default.createElement("button", { type: "button", className: "btn btn--sm flex-shrink-0 p-0 ps-2", onClick: handleClickFileUploadIcon },
                    react_1.default.createElement("svg", { className: "icon mb-0 gray", width: "25", height: "25" },
                        react_1.default.createElement("use", { href: "#paper-clip" }))),
                react_1.default.createElement("textarea", { rows: 1, ref: textareaRef, className: "m-1 rounded bg-white p-1 px-3", name: "message", placeholder: latestRequest &&
                        window.Translator.trans("chat.message_to", {
                            name: "".concat(latestRequest.name + " " + latestRequest.surname),
                        }, "js"), value: (_b = message.message) !== null && _b !== void 0 ? _b : "", onChange: function (e) {
                        return setMessage(function (prev) {
                            return __assign(__assign({}, prev), { message: e.target.value });
                        });
                    } }),
                react_1.default.createElement("button", { type: "submit", className: "ps-1 flex-shrink-0" },
                    react_1.default.createElement("svg", { className: "icon gray mb-0", width: "25", height: "25" },
                        react_1.default.createElement("use", { href: "#paper-plane" })))))));
}
exports.default = MessageInputArea;
